import React, { useEffect, useState,useCallback } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import Select from "react-select";
import {CircleLoader} from 'react-spinners';
import _ from 'lodash'


const pageSize = 5;
const Tcassignmain = () => {

  /*----Display TC users ----*/

  const token = JSON.parse(localStorage.getItem('usertoken'));
 
  const [name,setName]= useState([{}])
  const[details, setDetails] =useState([])
  const[Assigndetails, setAssigndetails] =useState([])
 
  const[pop,setpop] = useState(false);
  const [allusers,setAllusers]= useState([])
  const [selectedOptions, setSelectedOptions] = useState();

  const [paginatedPosts, setpaginatedPosts] = useState();
  //const [currentPage, setcurrentPage] = useState(1);
  
  const [selectedName, setSelectedName] = useState();

 
  useEffect(()=>{
    //setpop(true);
       
  //   setTimeout(()=>{
  //   setpop(false);
  // },1000)
  getAssignUser()
  getUser()
  },[1])

  function getUser(){
  
    fetch('https://localhost:44312/Api/Tc/GetTcusers', {
      method:'GET',
      headers : {

        "Content-type": "application/json",

        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },

      //body:JSON.stringify(data)

    }).then(response => response.json())
    .then(data => {
      console.log("Data",data)
    
      setName(data);

      localStorage.setItem("TcUserNames", JSON.stringify(data));
    });
  
  }
  
//   let Tcrole =  localStorage.getItem("TcUserNames");
//   let roledata =  JSON.parse(Tcrole);
//   let role = roledata.map((e)=>e.userName);
//   console.log(role);
//   let roles = role.toString();
//   console.log(roles)


// const list = [
//   { value: role[0], label:role[0] }, 
//    { value: role[1], label:role[1] },
//      { value: role[2], label:role[2] },  
//      { value: role[3], label:role[3] }, 
//    { value: role[4], label:role[4] }, 
//     { value: role[5], label:role[5] }, 
//      { value: role[6], label:role[6] },
//      { value: role[7], label:role[7] },
//      { value: role[8], label:role[8] },
//     //  { value: role[9], label:role[9] },
//     //  { value: role[10], label:role[10] },

// ];

  function getAssignUser(){
  
    fetch('https://localhost:44312/Api/Tc/GetAssignTcusers', {
      method:'GET',
      headers : {

        "Content-type": "application/json",

        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },

      //body:JSON.stringify(data)

    }).then(response => response.json())
    .then(data => {
      console.log("Data",data)
      setAssigndetails(data);
      //localStorage.setItem("SectionData", JSON.stringify(data));
      setAllusers(data)
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      localStorage.setItem("TcAssignUsers", JSON.stringify(data));
    });
   
  }
 
  // const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;

  // const pages = _.range(1, pageCount+1)
  
  // const pagination =(pageNo)=>{
  // setcurrentPage(pageNo);
  // const startIndex = (pageNo - 1) * pageSize;
  // const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
  // setpaginatedPosts(paginatedPost)
  // }
 

 
  const optionList = [
    { value: "Winner", label: "Winner" },
    { value: "AboutUs", label: "AboutUs" },
    { value: "Terms&Conditions", label: "Terms&Conditions" },
    { value: "PrivacyPolicy", label: "PrivacyPolicy" },
    { value: "Unfollow", label: "Unfollow" },
    { value: "Report", label: "Report" },
    { value: "Transaction", label: "Transaction" }
  ];

  const list=[name]

  function handleSelect(data) {
    setSelectedOptions(data);
  }

  // function selectName(data) {
  //   setSelectedName(data);
  // }


   // AssignSection
   function AssignSection(){

    
     var Name = document.getElementById('UserName').value

     let assign = selectedOptions.map((item) => item.label);
   console.log(assign)
   //const allFruits = Object.assign({}, ...assign);
   let section = assign.toString();


   
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  
    
    const body ={
     
      name:Name,
      section:section,
      assignStatus:0
    }
   
    console.log(body);
    axios({

      method:"POST",
       //url: `${BASE_URL}/Tc/AssignSection`,
      url:"https://localhost:44312/Api/Tc/AssignSection",
      data:body,
      headers: {
        "Content-Type" : "application/json",
        'Authorization':bearer 
      }

  })
  .then((response) =>{
    console.log(response.data);
    if(response.data.status=='Success'){
      document.getElementById('success-notify').style.display = "block"
       setTimeout(()=>{
         document.getElementById('success-notify').style.display = "none"
       },1000)
    }
    //alert("Section Assigned Successfully ")
  
      getUser()
      getAssignUser()
      document.getElementById("AssignTbl").reset();
      setSelectedOptions("")
 
   })
   .catch(error => {
   console.log(error);
  alert("failed !")

    })
    }

    //delete btn func
function DeleteStatus(Id,userName){

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   const body ={
    id: Id
  }
   console.log(body)
    axios({
   
    method:"POST",
    //url: `${BASE_URL}/Tc/DeleteStatus`,
   url:"https://localhost:44312/Api/Tc/DeleteAssignTcUser",
   data:body,
   headers: {
   "Content-Type" : "application/json",
   'Authorization':bearer
   }

   
  
    })
    .then((response) =>{
    console.log(response.data);
    //window.location.reload();
    
    if(response.data.status === "Success"){

    
      if(response.data.status=='Success'){
        document.getElementById('del-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('del-notify').style.display = "none"
         },1000)
      }
      //alert("Deleted Successfully!");

        closedelForm()
        getUser()
        getAssignUser()
        // setTimeout(() => {        
        //    window.location.reload();
        // }, 5000);
     
    }

    })
 
    } 
    function getDetails(Id){
   
      let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
            
     const body ={
      
      id:Id
    
     }
     console.log(body);
    
    
      axios({          
         method: "POST", 
         //url: `${BASE_URL}/Tc/EditSection`,      
         url: "https://localhost:44312/Api/Tc/GetTcPrUser",
         data:body,
         headers: {             
           'Content-Type': 'application/json' , 
           'Authorization':bearer     
         }
       
       })
       .then((response) =>{
        console.log(response.data);
        setDetails(response.data)
    
        localStorage.setItem("deluser",JSON.stringify(response.data));
        let Tcuser =  localStorage.getItem("deluser");
        let data =  JSON.parse(Tcuser);
        let user = data.map((e)=>e.userName);
        setSelectedName(user);
         }) 
    
    } 


    function ConfirmDelete(Id){

      document.getElementById("modalDeleteForm").style.display = "block";
      getDetails(Id)

    }

    function closedelForm()
{
   document.getElementById("modalDeleteForm").style.display = "none";
 
 }

 function Cancel() {
  document.getElementById("modalDeleteForm").style.display = "none";      
  
     }
    
     const LEFT_PAGE = "LEFT";
    const RIGHT_PAGE = "RIGHT";
    const range = (from, to, step = 1) => {
      let i = from;
      const range = [];
    
      while (i <= to) {
        range.push(i);
        i += step;
      }
    
      return range;
    };
    
    const [currentPage, setCurrentPage] = useState(1);
    
    let data = localStorage.getItem("TcAssignUsers")
    let transdata =  JSON.parse(data);
    let NUM_OF_RECORDS = transdata.length;
    let LIMIT = 5;
    
    const onPageChanged = useCallback(
    
      (event, page) => {
        event.preventDefault();
        setCurrentPage(page);
      },
      [setCurrentPage]
      
    );
    
    
    const currentData = transdata.slice(
      (currentPage - 1) * LIMIT,
      (currentPage - 1) * LIMIT + LIMIT
    );
    
    const [totalPages, setTotalPages] = useState(0);

    const Paginations = (props) => {
      const {
        totalRecords,
        pageLimit,
        pageNeighbours,
        onPageChanged,
        currentPage
      } = props;

     

      useEffect(() => {
        setTotalPages(Math.ceil(totalRecords / pageLimit));
      }, [setTotalPages]);
    
      const fetchPageNumbers = () => {
        const totalNumbers = pageNeighbours * 2 + 3;
        
        console.log('total',totalNumbers)
        console.log(pageNeighbours)
        const totalBlocks = totalNumbers + 2;
        console.log(totalBlocks)
    
        if (totalPages > totalBlocks) {
          const startPage = Math.max(2, currentPage - pageNeighbours);
          const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
    
          let pages = range(startPage, endPage);
    
          const hasLeftSpill = startPage > 2;
          const hasRightSpill = totalPages - endPage > 1;
          const spillOffset = totalNumbers - (pages.length + 1);
    
          switch (true) {
            case hasLeftSpill && !hasRightSpill: {
              const extraPages = range(startPage - spillOffset, startPage - 1);
              pages = [LEFT_PAGE, ...extraPages, ...pages];
              break;
            }
            case hasLeftSpill && hasRightSpill:
            default: {
              pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
              break;
            }
          }
          return [1, ...pages, totalPages];
        }
        return range(1, totalPages);
      };
    
    
      const pages = fetchPageNumbers() || [];
      return (
        <nav aria-label="Countries Pagination">
          <ul className="pagination">
            {pages.map((page, index) => {
              if (page === LEFT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      href="/"
                      className="page-link"
                      aria-label="Previous"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                );
    
              if (page === RIGHT_PAGE)
                return (
                  <li key={index} className="page-item">
                    <a
                      className="page-link"
                      href="/"
                      aria-label="Next"
                      onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                );
    
              return (
                <li
                  key={index}
                  className={`Tc-page-item${currentPage === page ? " active" : ""}`}
                >
                  <a
                    className="page-link"
                    href="/"
                    onClick={(e) => onPageChanged(e, page)}
                  >
                    {page}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    };  
  return (
    
    /*----top bar----*/

 
   <div className='TC-addmain'>
   
     <div className="TC-addgrid-layout">
   <div className="TC-addmain-top">
   <div className='TC-addmain-back'>
     <Link to='/Thats Cool'><i className="fa-sharp fa-solid fa-backward"></i></Link>
     </div> 
     <span>Assign Page</span>
     </div>
     </div>
     

  <div className='TCtable'>
<div class="TC-Assigntable_responsive">
 <form id="AssignTbl"> 
  <table className='TC-tblhead'>
    <thead>
      <tr>      
        <th>USERNAME</th>
        <th>SECTION</th>
        <th>ASSIGN</th>
     </tr>
    </thead>
    <tbody>

 
      <tr>

        <td>
           
       <select id='UserName'>
          <option>UserNames</option>
       {name.map(e=>( <option id='namelist'>{e.userName}</option> ))}
       </select>
 
          </td>    
          
        <td>          
       <div style={{inlineSize:"280px",overflowWrap:"break-word",wordWrap:"break-word"}}> <Select  
      className="dropdown"
  options={optionList}
  placeholder="Select Section"
  value={selectedOptions}
  onChange={handleSelect}
  isSearchable={true}
  isMulti
  isClearable
/></div>

 </td>

<td>
    <button className='TC-assign-btn' onClick={AssignSection}>ASSIGN</button> 
</td>

      </tr>
  

 </tbody>
</table>
</form> 
</div>
</div>

{/*  section display table */}

<div className='TCtable'>
<div class="TC-table_responsive">
{
  currentData.length==0 ? (<span style={{display:'flex',justifyContent:'center'}}>No Data Found</span>):(
  <table  id='TCtable' className='Assign-getTbl'>
    <thead>
      <tr>      
        <th>UserName</th>
        <th>Section</th>
        <th>Action</th>
     </tr>
    </thead>
    <tbody>
    {currentData.map((e,index)=>{
      return<tr key={index}>
        <td>{e.userName}</td>      
        <td>
        {e.section} 
      </td> 
      <td id='ActionData' style={{inlineSize:"50px",overflowWrap:"break-word",wordWrap:"break-word"}}>

<i className="fa-solid fa-trash" id='Tcdelicon' onClick={()=>ConfirmDelete(e.id)}></i></td>

      </tr>
    })}

    
 </tbody>
</table>
)}
<br></br>
{
  !paginatedPosts ? (""):(
<nav id='Tc-Pag'>
{transdata.length<=5 ? null:<ul className='Tc-pagination'>

    <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={3}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}  >
          
            {page}
            </p>
            </li>
        ))
      } */}
       

    </ul>}
  </nav>
  )}
</div>
</div>

<div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>Section <span style={{color:"blue"}}>Assigned</span> </p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>

<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>User&nbsp; <span style={{color:"red"}}>Deleted</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>
<div className="TCpopfade" id="modalDeleteForm" tabindex="-1" role="dialog">
{details.map((e)=>
{
return<div>
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>
   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
          <h5>Are you sure want to&nbsp;<span style={{color:"red"}}>Delete?</span></h5>
          <h5 style={{color:'blue'}}>{selectedName}</h5> 
          </div>
        </div>
   </div>

      <div className="modal-footer d-flex justify-content-center">
       <button className='TC-logout-button' onClick={()=>DeleteStatus(e.id,e.userName)} type='submit'>Confirm</button>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>
      </form>
      
    </div>
  </div>
  </div>
  }
 )}
     </div>

     {pop? <div id="Loader">

<CircleLoader color="grey" />
     </div>
 :null}
</div>


 
  )
}

export default Tcassignmain